import { render, staticRenderFns } from "./AccessRequest.vue?vue&type=template&id=354c3b2c&scoped=true"
import script from "./AccessRequest.vue?vue&type=script&lang=js"
export * from "./AccessRequest.vue?vue&type=script&lang=js"
import style0 from "./AccessRequest.vue?vue&type=style&index=0&id=354c3b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c3b2c",
  null
  
)

export default component.exports